export default theme => ({
  iconValueMainContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  iconValueValue: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  exploitsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: theme.spacing(1)
  }
});
